var currentUrl = window.location.href;
const defaults = {
    cartModal: '.js-ajax-cart-modal', // classname
    cartModalContent: '.js-ajax-cart-modal-content', // classname
    cartDrawer: '.js-ajax-cart-drawer', // classname
    cartDrawerContent: '.js-ajax-cart-drawer-content', // classname
    cartDrawerClose: '.js-ajax-cart-drawer-close', // classname
    cartDrawerTrigger: '.js-ajax-cart-drawer-trigger', // classname
    cartOverlay: '.js-ajax-cart-overlay', // classname
    cartCounter: '.cartCount', // classname
    addToCart: '.js-ajax-add-to-cart', // classname
    removeFromCart: '.js-ajax-remove-from-cart', //classname
    removeFromCartNoDot: 'js-ajax-remove-from-cart', //classname,
    checkoutButton: '.js-ajax-checkout-button',
};

const cartModal = document.querySelector(defaults.cartModal);
const cartModalContent = document.querySelector(defaults.cartModalContent);
const cartDrawer = document.querySelector(defaults.cartDrawer);
const cartDrawerContent = document.querySelector(defaults.cartDrawerContent);
const cartDrawerClose = document.querySelector(defaults.cartDrawerClose);
const cartDrawerTrigger = document.querySelector(defaults.cartDrawerTrigger);
const cartOverlay = document.querySelector(defaults.cartOverlay);
const cartCounter = document.querySelector(defaults.cartCounter);
const addToCart = document.querySelectorAll(defaults.addToCart);
let removeFromCart = document.querySelectorAll(defaults.removeFromCart);
const checkoutButton = document.querySelector(defaults.checkoutButton);
const htmlSelector = document.documentElement;

for (let i = 0; i < addToCart.length; i++) {

    addToCart[i].addEventListener('click', function(event) {

        event.preventDefault();
        const formID = document.getElementsByClassName("atc-cart")[0].getAttribute('id');
        
        addProductToCart(formID);
    });

}

function addProductToCart(formID) {
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#' + formID)
            .serialize(),
        success: addToCartOk,
        error: addToCartFail,
    });

}

function fetchCart() {
    $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function(cart) {
            onCartUpdate(cart);

            if (cart.item_count === 0) {
                cartDrawerContent.innerHTML = `<div class="cart-empty">
                    <h5 class="cart-empty__title">Your cart is currently empty.</h5>
                    <span class="emoji cart-empty__emoji">
                        <i class="icon icon--sad"></i>
                    </span>
                    <a href="/collections/all" class="c-btn c-btn--primary c-btn--full">Shop now</a>
                </div>`;
                //checkoutButton.classList.add('is-hidden');
               $(".ajax-cart-drawer__button-and-subtotal").addClass("is-hidden");
              $(".free-shipping-heading").html("").addClass("empty");
              $(".subtotal-amount").html("");
              $(".items-in-cart").html("");
            } else {
                renderCart(cart);
                //checkoutButton.classList.remove('is-hidden');
              $(".ajax-cart-drawer__button-and-subtotal").removeClass("is-hidden");
               $(".free-shipping-heading").removeClass("empty");
            }

        }
    });
}

function changeItem(data, callback) {
    const quantity = data.quantity;
    $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: 'quantity=' + quantity + '&line=' + data.line,
        dataType: 'json',
        success: function(cart) {
            if ((typeof callback) === 'function') {
                callback(cart);
            } else {
                onCartUpdate(cart);
                fetchCart();
                removeProductFromCart();
            }
        },
    });
}

function onCartUpdate(cart) {
    // console.log(document.getElementsByClassName("cartCount")[0].innerHTML)
    // var counts = document.getElementsByClassName("cartCount");

    // for(var i = 0; i < counts.length; i++){
    //     counts[i].innerHTML = cart.item_count;
    //     counts[i].dataset.count = cart.item_count;
    //     console.log(counts[i].innerHTML)
    // } 
}

function addToCartOk(product) {
    //cartModalContent.innerHTML = product.title + ' was added to the cart!';
    // cartCounter.innerHTML = Number(cartCounter.innerHTML) + 1;
    openCartDrawer();
    openCartOverlay();
    fetchCart();
}

function removeProductFromCart() {
    // cartCounter.innerHTML = Number(cartCounter.innerHTML) - 1;
}

function addToCartFail() {
    cartModalContent.innerHTML = 'The product you are trying to add is out of stock.';
    openAddModal();
    openCartOverlay();
}

function renderCart(cart) {

    clearCartDrawer();
let moneyFormat = null;
    cart.items.forEach(function(item, index) {
        let itemPropertiesHtml = "";
        let itemProperties = item.variant_options;
        
      
      if(itemProperties && Object.keys(itemProperties).length) {
        for (let key in itemProperties) {
          
            if(!key.startsWith("_") && itemProperties[key] != "Default Title")
              
              itemPropertiesHtml += `<p class="ajax-cart-item-property">${itemProperties[key]}</p>`;
		}
      }
      
      let linePriceHtml = "";
      
      if(item.final_line_price < item.original_line_price) {
        
        linePriceHtml = `<span class="compare-at-line-price"><s>${Shopify.formatMoney(item.original_line_price, moneyFormat)}</s></span><span class="original-line-price">${Shopify.formatMoney(item.final_line_price, moneyFormat)}</span>`;
        
      } else {
      
        linePriceHtml = `<span class="original-line-price">${Shopify.formatMoney(item.final_line_price, moneyFormat)}</span>`;
      }
      
      let cartItemHtml = `<div class="ajax-cart-item" data-line="${Number(index + 1)}">
<div class="ajax-cart-item-image-container"><a href="${item.url}"><img class="ajax-cart-item__image" alt="${item.title}" src="${item.image}" ></a></div>
<div class="ajax-cart-item-middle-part">
<div class="ajax-cart-item__title"><a href="${item.url}">${item.title}</a></div>
<div class="ajax-cart-item-properties">${itemPropertiesHtml}</div>
<div class="ajax-cart-item-quantity-container">
<div class="cart-item__qty"><div class="js-qty">
        <button type="button" class="js-qty__adjust js-qty__adjust--minus icon-fallback-text" data-id="${item.key}">
            <span aria-hidden="true">−</span>
        </button>
<input type="text" class="js-qty__num ajax-cart-item__quantity" value="${item.quantity}" min="1" data-id="${item.key}" aria-label="quantity" pattern="[0-9]*" id="updates_${item.key}">
        <button type="button" class="js-qty__adjust js-qty__adjust--plus" data-id="${item.key}" >
            <span aria-hidden="true">+</span>

        </button>
    </div>
</div>
</div>
</div>
		<div class="price-and-remove-item-wrapper">
<div class="ajax-cart-item__price">${linePriceHtml}</div>
<div class="ajax-cart-item-remove  ${defaults.removeFromCartNoDot}"><i class="icon icon--close" aria-hidden="true"></i>X</div></div></div>`
        cartDrawerContent.innerHTML = cartDrawerContent.innerHTML + cartItemHtml;

    });

  $(".items-in-cart").html(`${cart.item_count} items in your cart`);
  $(".subtotal-amount").html(Shopify.formatMoney(cart.total_price, moneyFormat));

  
//   freeShippingMessage(cart);
   
    removeFromCart = document.querySelectorAll(defaults.removeFromCart);

    for (let i = 0; i < removeFromCart.length; i++) {
        removeFromCart[i].addEventListener('click', function() {
            //const line = this.parentNode.getAttribute('data-line');
          
          const line = $(this).closest(".ajax-cart-item").data("line");
            
          let data = {
            line: line,
            quantity: 0
          };
            changeItem(data);
        });
    }


}

function openCartDrawer() {
  
    cartDrawer.classList.add('is-open');
  $('html').addClass('cart-drawer-open');
}

function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
  $('html').removeClass('cart-drawer-open');
}

function clearCartDrawer() {
    cartDrawerContent.innerHTML = '';
}

function openAddModal() {
    cartModal.classList.add('is-open');
}

function closeAddModal() {
    cartModal.classList.remove('is-open');
}

function openCartOverlay() {
    cartOverlay.classList.add('is-open');
    htmlSelector.classList.add('is-locked');
}

function closeCartOverlay() {
    cartOverlay.classList.remove('is-open');
    htmlSelector.classList.remove('is-locked');
}

cartDrawerClose.addEventListener('click', function() {
    closeCartDrawer();
    closeCartOverlay();
});
// cart is empty stanje
cartOverlay.addEventListener('click', function() {
    closeAddModal();
    closeCartDrawer();
    closeCartOverlay();
});


if(!currentUrl.includes("/cart")) {
cartDrawerTrigger.addEventListener('click', function(event) {
 
    event.preventDefault();
    //fetchCart();w
    openCartDrawer();
    openCartOverlay();
});

function checkoutCart(){
    console.log("running atc.")
    hasRechargeProduct();
}


$(document).on("click", ".js-ajax-cart-drawer-trigger-mobile", function(event) {

  event.preventDefault();
    //fetchCart();
    openCartDrawer();
    openCartOverlay();
  
});
}
document.addEventListener('DOMContentLoaded', function() {
    fetchCart();
});

if(!currentUrl.includes("/cart")) {
$(document).on("click", '.js-qty__adjust', function(e) {
e.preventDefault();
  
  var $el = $(this)
  , id = $el.data('id')
  , $qtySelector = $el.siblings('.js-qty__num')
  , qty = parseInt($qtySelector.val().replace(/\D/g, ''));
var qty = validateQty(qty);
if ($el.hasClass('js-qty__adjust--plus')) {
    qty += 1
} else {
    qty -= 1;
    if (qty < 1)
        qty = 0
}
  
  
$qtySelector.val(qty);
  
  let line = $(this).closest(".ajax-cart-item").data("line");
  
  let data = {
  
    line: line,
    quantity: qty
  }
  changeItem(data);
  
  
});
}
 validateQty = function(qty) {
   if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {} else {
     qty = 1
   }
   return qty
 }
 
 $(document).on("submit", ".js-ajax-cart-form.js-product-form", function(e) {
 
 e.preventDefault();
   
   
   $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $(this)
            .serialize(),
     success: function(response) {
     fetchCart();
     openCartDrawer();
     openCartOverlay();
    
     },
     error: function(error) {
     
     alert("This item is out of stock")
     },
    });

   return false;
 });

 function addItemToCart(variant_id, qty) {

    data = {
      "id": Number(variant_id),
      "quantity": qty
    }
    jQuery.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function () {
          fetchCart();
          openCartOverlay();
          openCartDrawer();
      
      },
  
      error: function () {
        alert("Sorry, That item is not available")
      }
    });
}
  
function reChargeProcessCart() {
	function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
	do {
      		token=get_cookie('cart');
	}
    while(token == undefined);	
    let myshopify_domain='men-face.myshopify.com'
	try { let ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
	return "https://checkout.rechargeapps.com/r/checkout?myshopify_domain="+myshopify_domain+"&cart_token="+token+"&"+ga_linker;
}


function hasRechargeProduct(){
    let isRechargeProduct = false;
    $.getJSON('/cart', function (results) {
    var has_subscription_product = false;
        $.each(results.items, function (i, item) {
            if( !has_subscription_product ){
                if(item.properties!== null){
                    $.each(item.properties, function (j, property) {
                        if(j=='shipping_interval_frequency'){
                            has_subscription_product = true;
                        }          
                    });
                }
            }  
        });
    if( has_subscription_product ){
        window.location.href = reChargeProcessCart();
    }else{
        window.location.href = "/checkout";
    }
});

    return isRechargeProduct;
}